import { validate as veeValidate } from 'vee-validate';

import { licenceNumberRules, licenceNumberRulesUpdated } from '@/helpers/products/car';

export default {
  validate: async (value, { part, isDrivingLicenceNumberValidationNew, partial = false }) => {
    const licenceNumberRulesToUse = isDrivingLicenceNumberValidationNew ? licenceNumberRulesUpdated : licenceNumberRules;
    const licenceNumberRulesKeys = Object.keys(licenceNumberRulesToUse).sort();

    let valid = true;
    if (part && licenceNumberRulesKeys.includes(part.toString())) {
      valid = await veeValidate(value, licenceNumberRulesToUse[part]);
    } else {
      const results = await Promise.all(
        licenceNumberRulesKeys
          .sort()
          .map(key => {
            const partRules = licenceNumberRulesToUse[key];
            const startingIndex = licenceNumberRulesKeys.reduce((acc, currentKey) => {
              return acc + (currentKey < key ? licenceNumberRulesToUse[currentKey].length : 0);
            }, 0);
            const valuePart = value.toString().substr(startingIndex, partRules.length);
            return veeValidate(valuePart.trim(), {
              ...partRules,
              required: !partial,
            });
          }),
      );
      valid = !results.some(({ valid }) => valid === false);
    }
    return {
      valid,
      required: true,
    };
  },
  params: ['part', 'isDrivingLicenceNumberValidationNew', 'partial'],
  message: 'Please double-check, as the format of your Driving Licence Number appears to be incorrect.',
};
